import { Box, Button } from "@mui/material"
import { useNavigate } from "react-router-dom"

export default function Footer() {
    const currentYear = new Date().getFullYear()
    const navigate = useNavigate()

    function linkClicked() {
        // Handle link click
        navigate("/contact")
    }
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                m: 0,
                pt: 1,
                backgroundColor: "transparent",
                bottom: 0,
                minHeight: "5rem",
                width: "100%",
                zIndex: 2,
            }}
        >
            <footer className="Footer">
                <Box component="span" sx={{ color: "text.primary" }}>
                    <Button
                        component="button"
                        variant="text"
                        sx={{ fontWeight: "bold", color: "primary.main" }}
                        onClick={linkClicked}
                    >
                        Aircrew Port Pages
                    </Button>
                    <br />
                    Copyright &copy; {currentYear}
                </Box>
            </footer>
        </Box>
    )
}
